import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./FinancialStageCell.module.scss";
import { convertCompanyStatus } from "@/frontend/shared/lib/convertCompanyStatus/convertCompanyStatus";

export function FinancialStageCell({ field }: { field: string }) {
  return (
    <Typography variant={"label-4"} color="greyscale900" className={styles.financialStageCell}>
      {convertCompanyStatus(field) || "-"}
    </Typography>
  );
}
